<as-split class="listing" direction="horizontal" [gutterSize]="18">
    <as-split-area [size]="30">
        <h3 class="header-title">Type & Group</h3>
        <div class="listing-tree">
            <mat-form-field>
                <mat-label>Import type</mat-label>
                <mat-select [(ngModel)]="selectedType" required>
                    <mat-option value="">Select the import type</mat-option>
                    <mat-option *ngFor="let type of potentialImportTypes" [value]="type">
                    {{ type }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field>
                <mat-label>Group</mat-label>
                <mat-select [(ngModel)]="selectedGroup" required>
                    <mat-option value="">Select a group</mat-option>
                    <mat-option *ngFor="let group of potentialGroups" [value]="group.id">
                    {{ group.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </as-split-area>

    <as-split-area [size]="70">
      <ng-container *ngIf="browseAreaVisible">
        <mat-toolbar class="editing-toolbar">
            <span>Browse file</span>

            <span class="spacer"></span>

            <button mat-raised-button class="tools-button" (click)="importData()" [disabled]="importButtonDisabled">
              <mat-icon svgIcon="content-save"></mat-icon>&nbsp;
              <span>Import</span>
            </button>
        </mat-toolbar>

        <div>
            <div class="import-header">
                <div class="template" *ngIf="selectedType != ''">
                    <p>By clicking on the below link, you can download a template of <b>{{selectedType}}</b></p>
                    <a target="_blank" [href]="downloadLinkUrl + this.selectedType + '.xlsx'">Download Template</a>
                </div>

                <div>
                    <h3>Upload an XLSX File</h3>
                    <input type="file" (change)="onFileChange($event)" accept=".xlsx, .xls" [disabled]="browseButtonDisabled" />
                </div>
            </div>

            <div class="import-body">
                <div class="import-stat">
                    <ul>
                        <li>Number of columns</li>
                        <li>{{ columns.length }}</li>
                        <li>Number of rows</li>
                        <li>{{ readData.length == 0 ? 0 : readData.length - 1 }}</li>
                    </ul>
                </div>

                <div *ngIf="validationErrors.length > 0" class="validation-error">
                    <h3>{{errorTitle}}</h3>
                    <ul>
                      <li *ngFor="let error of validationErrors">
                        {{ error }}
                      </li>
                    </ul>
                </div>

                <div *ngIf="readyToImport" class="import-button-area">
                    <div class="success-message">{{successMessage}}</div>
                </div>
            </div>
        </div>
      </ng-container>
    </as-split-area>
</as-split>

